// Clase de utilidad para validar y corregir consultas SQL
export default class SQLValidator {
    constructor() {
        // CORREGIDO: Conflictos de tipos actualizados basado en tipos reales
        this.typeConflicts = [
            { pattern: /JOIN\s+\w+\s+\w+\s+ON\s+(\w+\.\w+)\s*=\s*(\w+\.\w+)/gi, types: ['integer', 'text'] },
            { fields: ['sku_client', 'store_id', 'upc'], potentialConflict: true },
            // Conflictos potenciales entre REAL y TEXT
            { pattern: /WHERE\s+(\w+\.\w+|\w+)\s*[<>=!]+\s*'([^']+)'/gi, types: ['real', 'text'] }
        ];

        // Tablas y campos (sin cambios)
        this.tables = {
            'public.my_data': [
                'year', 'month', 'week', 'date', 'store_id', 'desc_tienda',
                'category', 'sku_client', 'item_desc', 'net_sales', 'units', 'final_price'
            ],
            'public.competitors_data': [
                'year', 'month', 'week', 'date', 'competitor', 'category',
                'brand', 'upc', 'item_desc', 'price', 'sales_flag', 'final_price', 'sku_client'
            ],
            // Permitir también sin el prefijo 'public.'
            'my_data': [
                'year', 'month', 'week', 'date', 'store_id', 'desc_tienda',
                'category', 'sku_client', 'item_desc', 'net_sales', 'units', 'final_price'
            ],
            'competitors_data': [
                'year', 'month', 'week', 'date', 'competitor', 'category',
                'brand', 'upc', 'item_desc', 'price', 'sales_flag', 'final_price', 'sku_client'
            ]
        };

        // Alias de tablas (sin cambios)
        this.aliasMap = {
            'md': 'my_data',
            'cd': 'competitors_data',
            'pmd': 'public.my_data',
            'pcd': 'public.competitors_data'
        };

        // CORREGIDO: Tipos de compatibilidad actualizados basados en tipos reales
        this.typeCompatibility = {
            // my_data (public.my_data) - TIPOS CORREGIDOS
            'my_data.year': 'integer',                      // ✅ CORREGIDO: era 'text'
            'my_data.month': 'text',                        // ✅ Correcto
            'my_data.week': 'text',                         // ✅ Correcto
            'my_data.date': 'date',                         // ✅ CORREGIDO: era 'timestamp without time zone'
            'my_data.store_id': 'integer',                  // ✅ CORREGIDO: era 'bigint'
            'my_data.desc_tienda': 'text',                  // ✅ Correcto
            'my_data.category': 'text',                     // ✅ Correcto
            'my_data.sku_client': 'integer',                // ✅ CORREGIDO: era 'bigint'
            'my_data.item_desc': 'text',                    // ✅ Correcto
            'my_data.net_sales': 'real',                    // ✅ CORREGIDO: era 'double precision'
            'my_data.units': 'real',                        // ✅ CORREGIDO: era 'double precision'
            'my_data.final_price': 'real',                  // ✅ CORREGIDO: era 'double precision'

            // competitors_data (public.competitors_data) - TIPOS CORREGIDOS
            'competitors_data.year': 'integer',             // ✅ CORREGIDO: era 'text'
            'competitors_data.month': 'text',               // ✅ Correcto
            'competitors_data.week': 'text',                // ✅ Correcto
            'competitors_data.date': 'date',                // ✅ CORREGIDO: era 'timestamp without time zone'
            'competitors_data.competitor': 'text',          // ✅ Correcto
            'competitors_data.category': 'text',            // ✅ Correcto
            'competitors_data.brand': 'text',               // ✅ Correcto
            'competitors_data.upc': 'integer',              // ✅ CORREGIDO: era 'text'
            'competitors_data.item_desc': 'text',           // ✅ Correcto
            'competitors_data.price': 'real',               // ✅ CORREGIDO: era 'double precision'
            'competitors_data.sales_flag': 'real',          // ✅ CORREGIDO: era 'text'
            'competitors_data.final_price': 'real',         // ✅ CORREGIDO: era 'double precision'
            'competitors_data.sku_client': 'integer',       // ✅ CORREGIDO: era 'bigint'

            // Con prefijo public. (copiar los mismos tipos corregidos)
            'public.my_data.year': 'integer',
            'public.my_data.month': 'text',
            'public.my_data.week': 'text',
            'public.my_data.date': 'date',
            'public.my_data.store_id': 'integer',
            'public.my_data.desc_tienda': 'text',
            'public.my_data.category': 'text',
            'public.my_data.sku_client': 'integer',
            'public.my_data.item_desc': 'text',
            'public.my_data.net_sales': 'real',
            'public.my_data.units': 'real',
            'public.my_data.final_price': 'real',

            'public.competitors_data.year': 'integer',
            'public.competitors_data.month': 'text',
            'public.competitors_data.week': 'text',
            'public.competitors_data.date': 'date',
            'public.competitors_data.competitor': 'text',
            'public.competitors_data.category': 'text',
            'public.competitors_data.brand': 'text',
            'public.competitors_data.upc': 'integer',
            'public.competitors_data.item_desc': 'text',
            'public.competitors_data.price': 'real',
            'public.competitors_data.sales_flag': 'real',
            'public.competitors_data.final_price': 'real',
            'public.competitors_data.sku_client': 'integer'
        };
    }

    // Método para limpiar formato Markdown
    // REEMPLAZAR COMPLETAMENTE el método cleanMarkdown en SQLValidator:

    cleanMarkdown(sql) {
        if (!sql || typeof sql !== 'string') return sql;

        console.log("🔧 DEBUG cleanMarkdown - Input:", sql);

        let cleanedSQL = sql;

        // 1. Limpiar formato Markdown básico
        cleanedSQL = cleanedSQL.replace(/^```sql\s*/gm, '');
        cleanedSQL = cleanedSQL.replace(/^```\s*/gm, '');
        cleanedSQL = cleanedSQL.replace(/\s*```$/gm, '');

        // 2. Limpiar comentarios con # (estilo Python/Shell)
        cleanedSQL = cleanedSQL.replace(/^#.*$/gm, '');
        cleanedSQL = cleanedSQL.replace(/\s*#[^\r\n]*/g, '');

        // 3. Limpiar títulos y texto descriptivo común
        cleanedSQL = cleanedSQL.replace(/^Consulta SQL.*$/gmi, '');
        cleanedSQL = cleanedSQL.replace(/^Query.*$/gmi, '');
        cleanedSQL = cleanedSQL.replace(/^Here.*SQL.*$/gmi, '');
        cleanedSQL = cleanedSQL.replace(/^Aquí.*SQL.*$/gmi, '');
        cleanedSQL = cleanedSQL.replace(/^La consulta.*$/gmi, '');
        cleanedSQL = cleanedSQL.replace(/^Esta consulta.*$/gmi, '');

        // 4. ✅ NUEVO: Extracción de SQL más inteligente
        // Buscar el SQL válido desde el primer SELECT, WITH, INSERT, UPDATE, DELETE
        // hasta el final o hasta encontrar texto explicativo

        // Primero, buscar donde empieza el SQL
        const sqlStartPattern = /(?:^|\n)\s*((?:SELECT|WITH|INSERT|UPDATE|DELETE)\b)/im;
        const sqlStartMatch = cleanedSQL.match(sqlStartPattern);

        if (sqlStartMatch) {
            const startIndex = cleanedSQL.indexOf(sqlStartMatch[1]);
            let sqlPart = cleanedSQL.substring(startIndex);

            console.log("🔧 DEBUG cleanMarkdown - SQL encontrado desde posición:", startIndex);
            console.log("🔧 DEBUG cleanMarkdown - SQL parte extraída:", sqlPart.substring(0, 100) + "...");

            // Buscar donde termina el SQL válido
            // Termina cuando encontramos explicaciones en español/inglés o cuando termina naturalmente
            const endPatterns = [
                /\n\s*(?:Esta consulta|This query|Explanation|Explicación|Note|Nota)/i,
                /\n\s*(?:El resultado|The result|Como se puede|As you can)/i,
                /\n\s*(?:\*\*|##|\d+\.)/m  // Markdown formatting o listas numeradas
            ];

            let endIndex = sqlPart.length;
            for (const pattern of endPatterns) {
                const match = sqlPart.match(pattern);
                if (match && match.index < endIndex) {
                    endIndex = match.index;
                }
            }

            cleanedSQL = sqlPart.substring(0, endIndex);
            console.log("🔧 DEBUG cleanMarkdown - SQL después de corte de final:", cleanedSQL.substring(0, 100) + "...");
        }

        // 5. Limpiar líneas vacías múltiples al principio y final
        cleanedSQL = cleanedSQL.trim();
        cleanedSQL = cleanedSQL.replace(/^\s*\n+/g, ''); // Líneas vacías al principio
        cleanedSQL = cleanedSQL.replace(/\n\s*\n\s*\n/g, '\n\n'); // Múltiples líneas vacías

        // 6. Asegurar que termine con punto y coma
        if (cleanedSQL && !cleanedSQL.trim().endsWith(';')) {
            cleanedSQL = cleanedSQL.trim() + ';';
        }

        // 7. ✅ VALIDACIÓN FINAL: Verificar que el SQL tiene estructura básica
        const hasSelect = /\bSELECT\b/i.test(cleanedSQL);
        const hasFrom = /\bFROM\b/i.test(cleanedSQL);
        const hasWithOrSelect = /\b(WITH|SELECT)\b/i.test(cleanedSQL);

        if (!hasWithOrSelect) {
            console.error("🚨 DEBUG cleanMarkdown - SQL no válido: no tiene SELECT o WITH");
            console.error("🚨 DEBUG cleanMarkdown - Devolviendo SQL original");
            return sql; // Devolver original si no podemos extraer SQL válido
        }

        // Para WITH statements, no necesariamente tiene FROM en el primer nivel
        if (cleanedSQL.toUpperCase().startsWith('SELECT') && !hasFrom) {
            console.error("🚨 DEBUG cleanMarkdown - SELECT sin FROM detectado");
            console.error("🚨 DEBUG cleanMarkdown - Devolviendo SQL original");
            return sql; // Devolver original si SELECT está incompleto
        }

        console.log("🔧 DEBUG cleanMarkdown - Output final:", cleanedSQL);

        return cleanedSQL;
    }

    // Verificar estructuras incompletas en SQL
    checkIncompleteStructures(sql) {
        const errors = [];

        // Verificar CASE/END balanceados
        const caseCount = (sql.match(/\bCASE\b/gi) || []).length;
        const endCount = (sql.match(/\bEND\b/gi) || []).length;

        if (caseCount > endCount) {
            errors.push(`Hay ${caseCount - endCount} declaraciones CASE sin cerrar con END`);
        }

        // Verificación para operaciones date-interval (actualizado para DATE)
        const dateIntervalOps = [...sql.matchAll(/(\w+\.\w+|\w+)\s*([<>=!]+)\s*.*?\s*(-|\+)\s*INTERVAL\s+\'([^\']+)\'/gi)];

        for (const match of dateIntervalOps) {
            const column = match[1];
            if (column.toLowerCase().includes('date') && !sql.includes(`CAST(${column}`)) {
                errors.push(`Posible error de tipo: columna '${column}' usada con INTERVAL sin CAST a DATE`);
            }
        }

        // Verificar subconsultas con MAX(date) o similar
        if (sql.includes("MAX(date)") &&
            sql.includes("INTERVAL") &&
            !sql.includes("CAST") &&
            sql.includes("-")) {
            errors.push("Posible error de incompatibilidad entre fecha como DATE e INTERVAL");
        }

        // Verificar operaciones aritméticas con INTERVAL sin CAST
        const intervalPatterns = [
            /\bINTERVAL\b.*?(-|\+)\s*(\w+\.\w+|\w+)/gi,
            /(\w+\.\w+|\w+)\s*(-|\+)\s*\bINTERVAL\b/gi
        ];

        for (const pattern of intervalPatterns) {
            const matches = [...sql.matchAll(pattern)];
            for (const match of matches) {
                const operand = match[2] || match[1];
                if (operand.toLowerCase().includes('date') && !sql.includes(`CAST(${operand}`)) {
                    errors.push(`Operación aritmética entre INTERVAL y '${operand}' sin CAST adecuado`);
                }
            }
        }

        // Verificar declaraciones CASE incompletas
        const incompleteCase = sql.match(/CASE\s*;/gi);
        if (incompleteCase) {
            errors.push('Declaración CASE incompleta encontrada');
        }

        // Verificar cláusulas WITH sin SELECT
        if (sql.includes('WITH') && !sql.includes('SELECT')) {
            errors.push('Cláusula WITH sin SELECT correspondiente');
        }

        return errors;
    }

    // Validar sintaxis básica de SQL
    validate(sql) {
        if (!sql || typeof sql !== 'string') {
            return { valid: false, errors: ['Consulta SQL vacía o inválida'] };
        }

        sql = sql.trim();
        const errors = [];

        // Verificaciones básicas
        if (!sql.toLowerCase().includes('select')) {
            errors.push('La consulta debe incluir una cláusula SELECT');
        }

        if (!sql.toLowerCase().includes('from')) {
            errors.push('La consulta debe incluir una cláusula FROM');
        }

        // Verificar paréntesis balanceados
        const openParens = (sql.match(/\(/g) || []).length;
        const closeParens = (sql.match(/\)/g) || []).length;
        if (openParens !== closeParens) {
            errors.push(`Paréntesis desbalanceados: ${openParens} abiertos vs ${closeParens} cerrados`);
        }

        // Verificar comillas balanceadas
        const quotes = (sql.match(/'/g) || []).length;
        if (quotes % 2 !== 0) {
            errors.push('Comillas simples desbalanceadas');
        }

        // Verificar alias de tablas
        for (const [alias, table] of Object.entries(this.aliasMap)) {
            if (sql.includes(`${alias}.`) &&
                !sql.includes(`${table} ${alias}`) &&
                !sql.includes(`${table} AS ${alias}`) &&
                !sql.includes(`public.${table} ${alias}`) &&
                !sql.includes(`public.${table} AS ${alias}`)) {
                errors.push(`Referencia a alias "${alias}" sin definición previa`);
            }
        }

        return {
            valid: errors.length === 0,
            errors: errors
        };
    }

    // Método principal para corregir consultas SQL
    fixQuery(sql, errorMessage = '') {
        let fixedSQL = sql.trim();
        let wasFixed = false;
        let fixes = [];

        // Limpiar formato Markdown
        const originalSQL = fixedSQL;
        fixedSQL = this.cleanMarkdown(fixedSQL);
        if (originalSQL !== fixedSQL) {
            wasFixed = true;
            fixes.push('Eliminado formato Markdown');
        }

        // Corregir nombres de tablas obsoletos
        const tableReplacements = {
            'datos_mercado': 'public.competitors_data',
            'mis_datos': 'public.my_data',
            'datos_geolocalizacion': null // Esta tabla ya no existe
        };

        for (const [oldTable, newTable] of Object.entries(tableReplacements)) {
            if (fixedSQL.includes(oldTable)) {
                const beforeTableFix = fixedSQL;
                if (newTable) {
                    fixedSQL = fixedSQL.replace(new RegExp(`\\b${oldTable}\\b`, 'g'), newTable);
                    wasFixed = true;
                    fixes.push(`Actualizado nombre de tabla: ${oldTable} → ${newTable}`);
                } else {
                    fixes.push(`ADVERTENCIA: Tabla ${oldTable} no existe en el nuevo esquema`);
                }
            }
        }

        // CORREGIDO: Nombres de columnas obsoletos actualizados
        const columnReplacements = {
            // Mapeo para la nueva estructura
            'precio_regular': 'price',                    // competitors_data
            'precio_sin_descuento': 'price',             // competitors_data  
            'precio': 'final_price',                     // ambas tablas
            'precio_venta': 'final_price',               // ambas tablas
            'ventas': 'net_sales',                       // my_data
            'unidades': 'units',                         // my_data
            'unidades_vendidas': 'units',                // my_data
            'store': 'desc_tienda',                      // my_data
            'tienda': 'desc_tienda',                     // my_data
            'product_id': 'sku_client',                  // ambas tablas
            'id_producto': 'sku_client',                 // ambas tablas
            'codigo_producto': 'sku_client',             // ambas tablas
            'categoria_principal': 'category',           // ambas tablas
            'promocion': 'sales_flag',                   // competitors_data
            'region': 'desc_tienda',                     // my_data (aproximación)
            'descripcion': 'item_desc',                  // ambas tablas
            'descripcion_producto': 'item_desc',         // ambas tablas
            'marca': 'brand',                            // competitors_data
            'competidor': 'competitor',                  // competitors_data
            'año': 'year',                               // ambas tablas
            'anio': 'year',                              // ambas tablas
            'mes': 'month',                              // ambas tablas
            'semana': 'week',                            // ambas tablas
            'fecha': 'date',                             // ambas tablas
            // Campos que ya no existen
            'mecanica_promocional': null,
            'zona': 'desc_tienda',
            'margen': null,
            'elasticidad': null,
            'llave': null,
            'canal': 'competitor',
            'latitud': null,
            'longitud': null,
            'ciudad': null,
            'estado': null,
            'distancia': null,
            'tipo': null
        };

        for (const [oldColumn, newColumn] of Object.entries(columnReplacements)) {
            if (fixedSQL.includes(oldColumn)) {
                if (newColumn) {
                    const beforeColumnFix = fixedSQL;
                    fixedSQL = fixedSQL.replace(new RegExp(`\\b${oldColumn}\\b`, 'g'), newColumn);
                    if (beforeColumnFix !== fixedSQL) {
                        wasFixed = true;
                        fixes.push(`Actualizado nombre de columna: ${oldColumn} → ${newColumn}`);
                    }
                } else {
                    fixes.push(`ADVERTENCIA: Columna ${oldColumn} no existe en el nuevo esquema`);
                }
            }
        }

        // Corregir función ROUND con AVG
        if (fixedSQL.includes('ROUND(') && fixedSQL.includes('AVG(')) {
            const beforeRoundFix = fixedSQL;
            fixedSQL = fixedSQL.replace(/ROUND\s*\(\s*AVG\s*\(\s*([^)]+)\s*\)\s*,\s*([0-9]+)\s*\)/g, 'ROUND(AVG($1)::numeric, $2)');

            if (beforeRoundFix !== fixedSQL) {
                wasFixed = true;
                fixes.push('Añadido cast ::numeric a función ROUND con AVG');
            }
        }

        // Corregir problemas con INTERVAL (actualizado para DATE)
        if (errorMessage.includes("operator does not exist: text - interval") ||
            (errorMessage.includes("operator does not exist") && errorMessage.includes("interval"))) {

            const beforeIntervalFix = fixedSQL;

            // Patrón para buscar comparaciones de date con intervalos
            const dateIntervalPattern = /(\w+\.\w+|\w+)\s*([<>=!]+)\s*\(?\s*(.+?)\s*\)?\s*(-|\+)\s*INTERVAL\s+\'([^\']+)\'/gi;

            fixedSQL = fixedSQL.replace(dateIntervalPattern, (match, column, operator, value, arithmeticOp, interval) => {
                let fixedColumn = column;
                if (column.toLowerCase().includes('date')) {
                    fixedColumn = `CAST(${column} AS DATE)`;
                }

                let fixedValue = value.trim();
                if (fixedValue.toUpperCase().includes('SELECT')) {
                    if (fixedValue.toLowerCase().includes('date')) {
                        fixedValue = `CAST((${fixedValue}) AS DATE)`;
                    }
                }

                return `${fixedColumn} ${operator} ${fixedValue} ${arithmeticOp} INTERVAL '${interval}'`;
            });

            // Patrón inverso (INTERVAL +/- fecha)
            const intervalDatePattern = /INTERVAL\s+\'([^\']+)\'\s*([+\-])\s*(\w+\.\w+|\w+)/gi;

            fixedSQL = fixedSQL.replace(intervalDatePattern, (match, interval, op, column) => {
                if (column.toLowerCase().includes('date')) {
                    return `INTERVAL '${interval}' ${op} CAST(${column} AS DATE)`;
                }
                return match;
            });

            // Funciones de fecha
            const dateFunctionPattern = /(EXTRACT|DATE_PART|DATE_TRUNC)\s*\(\s*\'?(\w+)\'?\s*,\s*(\w+\.\w+|\w+)\s*\)/gi;

            fixedSQL = fixedSQL.replace(dateFunctionPattern, (match, func, part, column) => {
                if (column.toLowerCase().includes('date')) {
                    return `${func}('${part}', CAST(${column} AS DATE))`;
                }
                return match;
            });

            if (beforeIntervalFix !== fixedSQL) {
                wasFixed = true;
                fixes.push('Aplicado CAST a columnas de fecha en operaciones con INTERVAL');
            }
        }

        // Problemas específicos con WHERE e INTERVAL
        if (errorMessage.includes("LINE") &&
            errorMessage.includes("WHERE") &&
            errorMessage.includes("INTERVAL") &&
            errorMessage.includes("HINT")) {

            const beforeWhereFix = fixedSQL;
            const wherePattern = /WHERE\s+(\w+\.\w+|\w+)\s*([<>=!]+)\s*(.+?)(INTERVAL\s+\'[^\']+\')/gi;

            fixedSQL = fixedSQL.replace(wherePattern, (match, column, operator, value, interval) => {
                let fixedColumn = column;
                if (column.toLowerCase().includes('date')) {
                    fixedColumn = `CAST(${column} AS DATE)`;
                }
                value = value.trim();
                return `WHERE ${fixedColumn} ${operator} ${value}${interval}`;
            });

            if (beforeWhereFix !== fixedSQL) {
                wasFixed = true;
                fixes.push('Aplicado CAST a columnas de fecha en cláusulas WHERE con INTERVAL');
            }
        }

        // Corregir función ROUND
        // Corregir función ROUND con mejor manejo
        if (errorMessage.includes("function round") && errorMessage.includes("does not exist")) {
            const beforeRoundFix = fixedSQL;

            console.log("🔧 DEBUG - Aplicando fix para función ROUND");
            console.log("🔧 DEBUG - SQL antes del fix:", beforeRoundFix);

            // 1. Fix básico: ROUND con operaciones simples
            fixedSQL = fixedSQL.replace(
                /ROUND\s*\(\s*([^,()]+)\s*,\s*([0-9]+)\s*\)/gi,
                'ROUND(CAST($1 AS NUMERIC), $2)'
            );

            // 2. Fix para ROUND con expresiones aritméticas simples (a/b, a*b, etc.)
            fixedSQL = fixedSQL.replace(
                /ROUND\s*\(\s*\(\s*([^()]+)\s*\)\s*,\s*([0-9]+)\s*\)/gi,
                'ROUND(CAST(($1) AS NUMERIC), $2)'
            );

            // 3. Fix para ROUND con divisiones específicas (campo / NULLIF(...))
            fixedSQL = fixedSQL.replace(
                /ROUND\s*\(\s*(\w+\.\w+|\w+)\s*\/\s*NULLIF\s*\(\s*([^)]+)\s*\)\s*,\s*([0-9]+)\s*\)/gi,
                'ROUND(CAST($1 AS NUMERIC) / NULLIF(CAST($2 AS NUMERIC), 0), $3)'
            );

            // 4. Fix para ROUND con funciones agregadas (AVG, SUM, etc.)
            fixedSQL = fixedSQL.replace(
                /ROUND\s*\(\s*(AVG|SUM|MIN|MAX|COUNT)\s*\(\s*([^)]+)\s*\)\s*,\s*([0-9]+)\s*\)/gi,
                'ROUND($1($2)::NUMERIC, $3)'
            );

            // 5. Fix para ROUND con expresiones complejas usando ::NUMERIC (más seguro)
            fixedSQL = fixedSQL.replace(
                /ROUND\s*\(\s*\(\s*([^)]+(?:\([^)]*\))*[^)]*)\s*\)\s*,\s*([0-9]+)\s*\)/gi,
                'ROUND(($1)::NUMERIC, $2)'
            );

            console.log("🔧 DEBUG - SQL después del fix:", fixedSQL);

            if (beforeRoundFix !== fixedSQL) {
                wasFixed = true;
                fixes.push('Añadido cast a NUMERIC para función ROUND');
            }
        }

        if (errorMessage.includes("syntax error at or near") && errorMessage.includes("AS")) {
            const beforeSyntaxFix = fixedSQL;

            console.log("🔧 DEBUG - Detectado error de sintaxis con AS, intentando corregir");
            console.log("🔧 DEBUG - SQL antes del fix de sintaxis:", beforeSyntaxFix);

            // Corregir CAST mal formateados (espacios incorrectos, paréntesis, etc.)

            // 1. Corregir CAST( ... AS NUMERIC) con espacios incorrectos
            fixedSQL = fixedSQL.replace(/CAST\s*\(\s*([^)]+)\s+AS\s+NUMERIC\s*\)/gi, 'CAST($1 AS NUMERIC)');

            // 2. Corregir CAST dobles accidentales
            fixedSQL = fixedSQL.replace(/CAST\s*\(\s*CAST\s*\(\s*([^)]+)\s*AS\s*NUMERIC\s*\)\s*AS\s*NUMERIC\s*\)/gi, 'CAST($1 AS NUMERIC)');

            // 3. Corregir paréntesis mal balanceados en CAST
            fixedSQL = fixedSQL.replace(/CAST\s*\(\s*\(\s*([^)]+)\s*AS\s*NUMERIC\s*\)/gi, 'CAST(($1) AS NUMERIC)');

            // 4. Usar :: en lugar de CAST cuando sea más simple
            fixedSQL = fixedSQL.replace(/CAST\s*\(\s*(\w+\.\w+|\w+)\s*AS\s*NUMERIC\s*\)/gi, '$1::NUMERIC');

            console.log("🔧 DEBUG - SQL después del fix de sintaxis:", fixedSQL);

            if (beforeSyntaxFix !== fixedSQL) {
                wasFixed = true;
                fixes.push('Corregida sintaxis de CAST/AS');
            }
        }


        // Corregir declaraciones CASE incompletas
        if (errorMessage.includes("syntax error") &&
            (errorMessage.includes("CASE") || fixedSQL.includes("CASE;"))) {

            const beforeCaseFix = fixedSQL;

            // Remover CASE; incompletos
            fixedSQL = fixedSQL.replace(/CASE\s*;/g, '');

            // Corregir CASE sin END
            const caseMatches = [...fixedSQL.matchAll(/(\bCASE\b(?:(?!\bEND\b).)*?)(?=\s*(?:FROM|WHERE|GROUP|ORDER|LIMIT|;|$))/gis)];

            for (const match of caseMatches) {
                const incompleteCase = match[0];
                if (!incompleteCase.includes('END')) {
                    if (incompleteCase.includes('WHEN')) {
                        fixedSQL = fixedSQL.replace(incompleteCase, `${incompleteCase} END`);
                    } else {
                        fixedSQL = fixedSQL.replace(incompleteCase, '');
                    }
                }
            }

            if (fixedSQL.trim().endsWith('CASE') || fixedSQL.trim().endsWith('CASE;')) {
                fixedSQL = fixedSQL.replace(/\bCASE\b\s*;?\s*$/, '');
            }

            if (beforeCaseFix !== fixedSQL) {
                wasFixed = true;
                fixes.push('Corregidas declaraciones CASE incompletas');
            }
        }

        // Operaciones aritméticas con problemas de tipo (actualizado para REAL)
        if (errorMessage.includes("operator does not exist") &&
            (errorMessage.includes("+") || errorMessage.includes("-") ||
                errorMessage.includes("*") || errorMessage.includes("/"))) {

            const beforeOpFix = fixedSQL;

            fixedSQL = fixedSQL.replace(
                /(\w+\.\w+|\w+)\s*(\+|\-|\*|\/)\s*(\w+\.\w+|\w+)/g,
                (match, left, op, right) => {
                    if (left.includes('CAST') || right.includes('CAST') ||
                        !isNaN(parseFloat(left)) || !isNaN(parseFloat(right))) {
                        return match;
                    }
                    return `CAST(${left} AS numeric) ${op} CAST(${right} AS numeric)`;
                }
            );

            if (beforeOpFix !== fixedSQL) {
                wasFixed = true;
                fixes.push('Añadido cast explícito para operaciones aritméticas');
            }
        }

        // División especial (prevenir división por cero)
        if (errorMessage.includes("division by zero") ||
            (errorMessage.includes("/") && errorMessage.includes("operator does not exist"))) {

            const beforeDivFix = fixedSQL;

            fixedSQL = fixedSQL.replace(
                /(\w+\.\w+|\w+)\s*\/\s*(\w+\.\w+|\w+)/g,
                (match, numerator, denominator) => {
                    if (match.includes('NULLIF')) return match;
                    return `CAST(${numerator} AS numeric) / NULLIF(CAST(${denominator} AS numeric), 0)`;
                }
            );

            if (beforeDivFix !== fixedSQL) {
                wasFixed = true;
                fixes.push('Añadida protección contra división por cero');
            }
        }

        // Comparaciones entre tipos diferentes (actualizado para INTEGER)
        if (errorMessage.includes("operator does not exist") && errorMessage.includes("=")) {
            const beforeCompFix = fixedSQL;

            if (fixedSQL.includes("JOIN") || fixedSQL.includes("WHERE")) {
                fixedSQL = fixedSQL.replace(
                    /(\w+\.\w+)\s*(=|<>|<|>|<=|>=)\s*(\w+\.\w+)/g,
                    (match, left, op, right) => {
                        // Para INTEGER, usar comparación directa; para otros, usar text
                        if (left.includes('sku_client') || right.includes('sku_client') ||
                            left.includes('store_id') || right.includes('store_id') ||
                            left.includes('year') || right.includes('year') ||
                            left.includes('upc') || right.includes('upc')) {
                            return match; // INTEGER puede compararse directamente
                        }
                        return `CAST(${left} AS text) ${op} CAST(${right} AS text)`;
                    }
                );
            }

            if (beforeCompFix !== fixedSQL) {
                wasFixed = true;
                fixes.push('Normalizado tipos en condiciones de comparación');
            }
        }

        // Convertir JOIN a LEFT JOIN cuando hay problemas
        if (errorMessage.includes("no rows returned") || (!errorMessage && wasFixed === false)) {
            const joinRegex = /\b(JOIN)\b/g;
            if (joinRegex.test(fixedSQL)) {
                const beforeJoinFix = fixedSQL;
                fixedSQL = fixedSQL.replace(joinRegex, 'LEFT JOIN');
                if (beforeJoinFix !== fixedSQL) {
                    wasFixed = true;
                    fixes.push('Cambiado JOIN a LEFT JOIN para garantizar al menos algunos resultados');
                }
            }
        }

        // Corregir errores de alias sin declarar
        for (const [alias, table] of Object.entries(this.aliasMap)) {
            if (fixedSQL.includes(`${alias}.`) &&
                !fixedSQL.includes(`${table} ${alias}`) &&
                !fixedSQL.includes(`${table} AS ${alias}`) &&
                !fixedSQL.includes(`public.${table} ${alias}`) &&
                !fixedSQL.includes(`public.${table} AS ${alias}`)) {

                if (fixedSQL.includes(`FROM ${table}`) || fixedSQL.includes(`FROM public.${table}`)) {
                    const beforeAliasFix = fixedSQL;
                    fixedSQL = fixedSQL.replace(`FROM ${table}`, `FROM ${table} ${alias}`)
                        .replace(`FROM public.${table}`, `FROM public.${table} ${alias}`);

                    if (beforeAliasFix !== fixedSQL) {
                        wasFixed = true;
                        fixes.push(`Añadido alias "${alias}" a la tabla "${table}"`);
                    }
                } else if (fixedSQL.includes(`JOIN ${table}`) || fixedSQL.includes(`JOIN public.${table}`)) {
                    const beforeAliasFix = fixedSQL;
                    fixedSQL = fixedSQL.replace(`JOIN ${table}`, `JOIN ${table} ${alias}`)
                        .replace(`JOIN public.${table}`, `JOIN public.${table} ${alias}`);

                    if (beforeAliasFix !== fixedSQL) {
                        wasFixed = true;
                        fixes.push(`Añadido alias "${alias}" a la tabla "${table}" en JOIN`);
                    }
                } else {
                    // Reemplazar alias por nombre completo
                    const beforeAliasFix = fixedSQL;
                    fixedSQL = fixedSQL.replace(new RegExp(`${alias}\\.`, 'g'), `${table}.`);

                    if (beforeAliasFix !== fixedSQL) {
                        wasFixed = true;
                        fixes.push(`Reemplazado alias "${alias}" por nombre completo "${table}"`);
                    }
                }
            }
        }

        // Corregir WHERE con operador lógico incorrecto
        if (/WHERE\s+AND/i.test(fixedSQL) || /WHERE\s+OR/i.test(fixedSQL)) {
            const beforeWhereFix = fixedSQL;
            fixedSQL = fixedSQL.replace(/WHERE\s+AND/i, 'WHERE').replace(/WHERE\s+OR/i, 'WHERE');

            if (beforeWhereFix !== fixedSQL) {
                wasFixed = true;
                fixes.push('Eliminado operador lógico innecesario después de WHERE');
            }
        }

        // Añadir punto y coma al final
        if (!fixedSQL.trim().endsWith(';')) {
            fixedSQL = fixedSQL.trim() + ';';
            wasFixed = true;
            fixes.push('Añadido punto y coma al final');
        }

        // Correcciones específicas basadas en mensajes de error
        if (errorMessage) {
            // Error de tabla no existente
            if (errorMessage.includes('relation') && errorMessage.includes('does not exist')) {
                const match = errorMessage.match(/relation\s+"?([^"]+)"?/i);
                if (match && match[1]) {
                    const badTable = match[1].trim();
                    let bestMatch = null;
                    let bestSimilarity = 0;

                    for (const table of Object.keys(this.tables)) {
                        const similarity = this.stringSimilarity(badTable, table);
                        if (similarity > bestSimilarity) {
                            bestSimilarity = similarity;
                            bestMatch = table;
                        }
                    }

                    if (bestMatch && bestSimilarity > 0.5) {
                        const beforeTableFix = fixedSQL;
                        fixedSQL = fixedSQL.replace(new RegExp(`\\b${badTable}\\b`, 'g'), bestMatch);

                        if (beforeTableFix !== fixedSQL) {
                            wasFixed = true;
                            fixes.push(`Corregido nombre de tabla "${badTable}" a "${bestMatch}"`);
                        }
                    }
                }
            }

            // Error de columna no existente (usando el mapeo actualizado)
            if (errorMessage.includes('column') && errorMessage.includes('does not exist')) {
                const match = errorMessage.match(/column\s+"?([^"]+)"?/i);
                if (match && match[1]) {
                    const badColumn = match[1].trim();

                    if (columnReplacements[badColumn]) {
                        const beforeColumnFix = fixedSQL;
                        fixedSQL = fixedSQL.replace(
                            new RegExp(`\\b${badColumn}\\b`, 'g'),
                            columnReplacements[badColumn]
                        );

                        if (beforeColumnFix !== fixedSQL) {
                            wasFixed = true;
                            fixes.push(`Corregido nombre de columna "${badColumn}" a "${columnReplacements[badColumn]}"`);
                        }
                    }
                }
            }

            // Errores de incompatibilidad integer = text (actualizado)
            if (errorMessage.includes("operator does not exist") &&
                (errorMessage.includes("integer = text") || errorMessage.includes("text = integer"))) {

                const beforeTypeFix = fixedSQL;
                const fieldsMatch = errorMessage.match(/ON\s+(\w+\.\w+)\s*=\s*(\w+\.\w+)/i);

                if (fieldsMatch && fieldsMatch.length >= 3) {
                    const leftField = fieldsMatch[1];
                    const rightField = fieldsMatch[2];

                    let integerField, textField;
                    if (errorMessage.includes("integer = text")) {
                        integerField = leftField;
                        textField = rightField;
                    } else {
                        integerField = rightField;
                        textField = leftField;
                    }

                    fixedSQL = fixedSQL.replace(
                        new RegExp(`(${leftField})\\s*=\\s*(${rightField})`, 'g'),
                        `${integerField} = CAST(${textField} AS integer)`
                    );

                    if (beforeTypeFix !== fixedSQL) {
                        wasFixed = true;
                        fixes.push(`Añadido CAST para convertir ${textField} a integer en JOIN`);
                    }
                } else {
                    // Buscar patrones de JOIN genéricos
                    const joinMatches = [...fixedSQL.matchAll(/JOIN\s+(\w+)(?:\s+AS)?(?:\s+)?(\w+)?\s+ON\s+(\w+)\.(\w+)\s*=\s*(\w+)\.(\w+)/gi)];

                    for (const joinMatch of joinMatches) {
                        const [fullMatch, table1, alias1, aliasRef1, field1, aliasRef2, field2] = joinMatch;

                        // Campos que son INTEGER
                        const integerFields = ["sku_client", "store_id", "year", "upc"];
                        if (integerFields.some(nf =>
                            field1.toLowerCase().includes(nf) || field2.toLowerCase().includes(nf))) {

                            const newJoin = fullMatch.replace(
                                `${aliasRef1}.${field1} = ${aliasRef2}.${field2}`,
                                `CAST(${aliasRef1}.${field1} AS text) = CAST(${aliasRef2}.${field2} AS text)`
                            );

                            fixedSQL = fixedSQL.replace(fullMatch, newJoin);
                            wasFixed = true;
                            fixes.push(`Añadido CAST a text en JOIN para ${aliasRef1}.${field1} = ${aliasRef2}.${field2}`);
                        }
                    }
                }
            }

            // Timeouts y consultas lentas
            if (errorMessage.includes("timeout") ||
                errorMessage.includes("execution time exceeded") ||
                errorMessage.includes("canceling statement due to")) {

                const beforeTimeoutFix = fixedSQL;

                if (fixedSQL.includes("WHERE") &&
                    /HAVING.*\(\s*SELECT.*WHERE.*=\s*\w+\.\w+/is.test(fixedSQL)) {

                    fixedSQL = fixedSQL.replace(
                        /(\(\s*SELECT\s+(?:(?!\bLIMIT\b).)*?)\)/gis,
                        "$1 LIMIT 1000)"
                    );

                    if (fixedSQL.toLowerCase().includes("order by") &&
                        !fixedSQL.toLowerCase().includes("limit")) {
                        if (!fixedSQL.toLowerCase().includes("limit")) {
                            fixedSQL = fixedSQL.replace(/;$/, " LIMIT 1000;");
                        }
                    }
                }

                if (beforeTimeoutFix !== fixedSQL) {
                    wasFixed = true;
                    fixes.push("Optimizada consulta para evitar timeout añadiendo LIMIT");
                }
            }
        }

        return {
            sql: fixedSQL,
            wasFixed,
            fixes
        };
    }

    // Calcular similitud entre cadenas
    stringSimilarity(s1, s2) {
        if (!s1 || !s2) return 0;
        s1 = s1.toLowerCase();
        s2 = s2.toLowerCase();
        if (s1 === s2) return 1.0;

        let matches = 0;
        for (let i = 0; i < Math.min(s1.length, s2.length); i++) {
            if (s1[i] === s2[i]) matches++;
        }
        return matches / Math.max(s1.length, s2.length);
    }

    // Procesar consulta completa
    processQuery(sql, errorMessage = '') {
        sql = this.cleanMarkdown(sql);

        // Verificar errores estructurales
        const structuralErrors = this.checkIncompleteStructures(sql);
        if (structuralErrors.length > 0) {
            console.warn("Errores estructurales detectados:", structuralErrors);
        }

        // Verificar elementos desbalanceados
        const unbalancedElements = this.checkUnbalancedElements(sql);
        if (unbalancedElements.length > 0) {
            console.warn("Elementos no balanceados:", unbalancedElements);
        }

        // Validación normal
        const validationResult = this.validate(sql);

        // Si hay errores o mensaje de error explícito, corregir
        if (!validationResult.valid || errorMessage ||
            structuralErrors.length > 0 || unbalancedElements.length > 0) {
            return this.fixQuery(sql, errorMessage);
        }

        return {
            sql: sql,
            wasFixed: false,
            fixes: []
        };
    }

    // Verificar elementos desbalanceados
    checkUnbalancedElements(sql) {
        const errors = [];

        // Verificar paréntesis balanceados
        const openParens = (sql.match(/\(/g) || []).length;
        const closeParens = (sql.match(/\)/g) || []).length;
        if (openParens !== closeParens) {
            errors.push(`Paréntesis desbalanceados: ${openParens} abiertos vs ${closeParens} cerrados`);
        }

        // Verificar comillas simples balanceadas
        const singleQuotes = (sql.match(/'/g) || []).length;
        if (singleQuotes % 2 !== 0) {
            errors.push('Comillas simples desbalanceadas');
        }

        // Verificar comillas dobles balanceadas
        const doubleQuotes = (sql.match(/"/g) || []).length;
        if (doubleQuotes % 2 !== 0) {
            errors.push('Comillas dobles desbalanceadas');
        }

        return errors;
    }
}